import { memo } from "react";

import { TableThWithSortIcon } from "@sso/components/TableThWithSortIcon";
import { useAppDispatch } from "@sso/hooks/useRedux";
import { setTraccUsageSortColumn } from "@sso/store/slices/traccUsage";
import { TableColumn } from "@sso/types";
import { LayoutTable, TableWrapper, TD, TH } from "@sso/ui/Table";

import { TraccUsageKeys } from "../../constant/traccUsage";
import { TraccUsage } from "../../types/traccUsage";

interface TraccUsageTableProps {
  traccUsages: TraccUsage[];
  columns: TableColumn<TraccUsageKeys>[];
}

export const TraccUsageTable = memo(({ traccUsages, columns }: TraccUsageTableProps) => {
  const dispatch = useAppDispatch();

  const handleSortAction = (column: string) => {
    dispatch(setTraccUsageSortColumn(column));
  };

  const formatDate = (value: string) => {
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return value;
    }

    const datePart = date.toLocaleDateString();
    const timePart = date.toLocaleTimeString(undefined, { hour12: false });
    const milliseconds = date.getMilliseconds().toString().padStart(3, "0"); // Ensures 3-digit ms
    return `${datePart} ${timePart}.${milliseconds}`;
  };

  return (
    <TableWrapper>
      <LayoutTable>
        <thead>
          <tr>
            {columns.map(col => (
              <TH key={col.field} sortable={col.sortable} onClick={() => col.sortable && handleSortAction(col.field)}>
                {col.sortable ? <TableThWithSortIcon column={col.field} title={col.name} /> : col.name}
              </TH>
            ))}
          </tr>
        </thead>
        <tbody>
          {traccUsages.map(x => (
            <tr>
              {columns.map(col => (
                <TD key={col.field}>
                  {col.field === TraccUsageKeys.CREATED_AT
                    ? formatDate((x as unknown as Record<string, string>)[col.field])
                    : (x as unknown as Record<string, string>)[col.field]}
                </TD>
              ))}
            </tr>
          ))}
        </tbody>
      </LayoutTable>
    </TableWrapper>
  );
});
